const c = (t, i) => {
  i && t && (typeof t == "function" ? t(i) : t.current = i);
};
export {
  c as bindForwardedRef
};
